var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tooltip',{attrs:{"target":_vm.target,"triggers":"hover focus click","show":_vm.showTooltip,"title":_vm.title,"custom-class":_vm.customClass},on:{"update:show":function($event){_vm.showTooltip=$event},"shown":_vm.hideTooltipLater}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }